import { addAllValue } from 'src/utils/DataTrees'
import { addAllValue as addAllValueV5 } from 'src/utils/v5/DataTrees'

import { NO_PROGRAM } from '../common/dropdownValues'

export const BILLING_STATUSES = new Map([
  [1, 'NEW'],
  [2, 'IN PROGRESS'],
  [5, 'INACTIVE'],
  [10, 'COMPLETED']
])

export const BILLING_STATUSE_COLORS = new Map([
  [1, '#0000FF'],
  [2, '#FFA500'],
  [5, '#808080'],
  [10, '#008000']
])

export const INVOICE_STATUSES = new Map([
  [1, 'BILLED'],
  [2, 'UNBILLED'],
  [3, 'RETRO']
])

export const INVOICE_STATUSES_COLORS = new Map([
  [1, '#008000'],
  [2, '#FF4848'],
  [3, '#FFA500']
])

export const BILLING_CODES = {
  0: ['G0506'],
  1: ['99490', '99439', '99487', '99489', '99491', '99437'],
  2: ['99453', '99454', '99457', '99458'],
  4: ['98975', '98976', '98977', '98980', '98981'],
  5: ['99484'],
  6: ['G0556', 'G0557', 'G0558'],
  7: [
    '99492',
    '99493',
    '99494',
    'T2022',
    'G2214',
    'MCRNP',
    'MCREP',
    'MCDNP',
    'MCDEP'
  ],
  8: ['G0023', 'G0024', 'G0140', 'G0146'],
  9: ['G0019', 'G0022'],
  10: ['99495', '99496'],
  11: ['99424', '99425', '99426', '99427']
}

export const BILLING_CODES_TYPES_VIEW_COLUMN = new Map([
  ['G0506', 0],
  ['CCM', 1],
  ['CoCM', 7],
  ['RPM', 2],
  ['RTM', 4],
  ['BHI', 5],
  ['APCM', 6],
  ['PIN', 8],
  ['G0023', 8],
  ['G0024', 8],
  ['G0140', 8],
  ['G0146', 8],
  ['CHI', 9],
  ['G0019', 9],
  ['G0022', 9],
  ['TCM', 10],
  ['99495', 10],
  ['99496', 10],
  ['PCM', 11],
  ['99424', 11],
  ['99425', 11],
  ['99426', 11],
  ['99427', 11]
])

export const BILLING_CODES_TYPES = new Map([
  ['no program', 0],
  ['ccm', 1],
  ['cocm', 7],
  ['rpm', 2],
  ['telemedicine', 3],
  ['rtm', 4],
  ['bhi', 5],
  ['apcm', 6],
  ['pin', 8],
  ['chi', 9],
  ['tcm', 10],
  ['pcm', 11]
])

export const BILLING_CODES_TYPES_MONITORING_DASHBOARD = new Map([
  ['G0506', 0],
  ['CCM', 1],
  ['CoCM', 7],
  ['RPM', 2],
  ['RTM', 4],
  ['BHI', 5],
  ['APCM', 6],
  ['PIN', 8],
  ['G0023', 8],
  ['G0024', 8],
  ['G0140', 8],
  ['G0146', 8],
  ['CHI', 9],
  ['G0019', 9],
  ['G0022', 9],
  ['TCM', 10],
  ['99495', 10],
  ['99496', 10],
  ['PCM', 11],
  ['99424', 11],
  ['99425', 11],
  ['99426', 11],
  ['99427', 11]
])

// TODO: recheck and fix no-program value usage
export const BILLING_CODES_TYPES_BY_NUMBERS = new Map([
  [
    0,
    {
      key: 'no program',
      label: 'Care Plan',
      title: 'Care Plan',
      value: 0
    }
  ],
  [
    1,
    {
      key: 'ccm',
      label: 'CCM',
      title: 'CCM',
      value: 1
    }
  ],
  [
    7,
    {
      key: 'cocm',
      label: 'CoCM',
      title: 'CoCM',
      value: 7
    }
  ],
  [
    2,
    {
      key: 'rpm',
      label: 'RPM',
      title: 'RPM',
      value: 2
    }
  ],
  [
    3,
    {
      key: 'telemedicine',
      label: 'Telemedicine',
      title: 'Telemedicine',
      value: 3
    }
  ],
  [
    4,
    {
      key: 'rtm',
      label: 'RTM',
      title: 'RTM',
      value: 4
    }
  ],
  [
    5,
    {
      key: 'bhi',
      label: 'BHI',
      title: 'BHI',
      value: 5
    }
  ],
  [
    6,
    {
      key: 'apcm',
      label: 'APCM',
      title: 'APCM',
      value: 6
    }
  ],
  [
    8,
    {
      key: 'pin',
      label: 'PIN',
      title: 'PIN',
      value: 8
    }
  ],
  [
    9,
    {
      key: 'chi',
      label: 'CHI',
      title: 'CHI',
      value: 9
    }
  ],
  [
    10,
    {
      key: 'tcm',
      label: 'TCM',
      title: 'TCM',
      value: 10
    }
  ],
  [
    11,
    {
      key: 'pcm',
      label: 'PCM',
      title: 'PCM',
      value: 11
    }
  ]
])

export const BILLING_CODES_TYPES_BY_NUMBERS_WITH_NO_PROGRAM = Array.from(
  BILLING_CODES_TYPES_BY_NUMBERS
)
  .map(([__, item]) =>
    item.value === 0
      ? {
          ...item,
          value: 'no-program',
          label: 'No Program',
          title: 'No Program'
        }
      : item
  )
  .filter(
    ({ value }) =>
      ![
        BILLING_CODES_TYPES_BY_NUMBERS.get(0).value,
        BILLING_CODES_TYPES_BY_NUMBERS.get(3).value
      ].includes(value)
  )

export const BILLING_CODES_TYPES_BY_NUMBERS_FORM = Array.from(
  BILLING_CODES_TYPES_BY_NUMBERS
)
  .map(([__, item]) => item)
  .filter(
    ({ value }) =>
      ![
        BILLING_CODES_TYPES_BY_NUMBERS.get(0).value,
        BILLING_CODES_TYPES_BY_NUMBERS.get(3).value
      ].includes(value)
  )

export const BILLING_CODES_TYPES_BY_NUMBERS_DROPDOWN = [
  ...Array.from(BILLING_CODES_TYPES_BY_NUMBERS)
    .map(([__, item]) => item)
    .filter(
      ({ value }) =>
        ![
          BILLING_CODES_TYPES_BY_NUMBERS.get(0).value,
          BILLING_CODES_TYPES_BY_NUMBERS.get(3).value
        ].includes(value)
    ),
  NO_PROGRAM
]
export const BILLING_CODES_TYPES_BY_NUMBERS_DROPDOWN_WITH_ALL = addAllValue(
  BILLING_CODES_TYPES_BY_NUMBERS_DROPDOWN
)

export const BILLING_CODES_TYPES_BY_NUMBERS_DROPDOWN_WITHOUT_NO_PROGRAM =
  addAllValue(
    BILLING_CODES_TYPES_BY_NUMBERS_DROPDOWN.filter(
      (e) => e.value !== NO_PROGRAM.value
    )
  )

export const BILLING_CODES_TYPES_BY_NUMBERS_DROPDOWN_WITHOUT_NO_PROGRAM_V5 =
  addAllValueV5({
    list: BILLING_CODES_TYPES_BY_NUMBERS_DROPDOWN.filter(
      (e) => e.value !== NO_PROGRAM.value
    )
  })

export const BILLING_CODES_TYPES_BY_NUMBERS_DROPDOWN_WITH_ALL_V5 =
  addAllValueV5({
    list: BILLING_CODES_TYPES_BY_NUMBERS_DROPDOWN
  })
